export default __webpack_public_path__ + "4226f91adb29e91b1104ae7a7f8ace22.webp";